export const formatNumberToCurrency = (
  value?: number,
  currencyCode: string = 'USD',
  fractionDigits: number = 2,
) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode,
    currencySign: 'standard', // Removed accounting as we need -$1,234.00 instead of ($1,234.00)
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
  return formatter.format(value ?? 0);
};

export const getCurrencyStringTitleForChart = (value: number) => {
  const formatter = Intl.NumberFormat('en', {
    notation: 'compact',
    signDisplay: 'never',
  });
  const prefix = value >= 0 ? '$' : '-$';
  return `${prefix}${formatter.format(value)}`;
};

export const formatSeriesTooltipCurrency = (value: number | null) => {
  if (!value) {
    return formatNumberToCurrency(0);
  }

  return formatNumberToCurrency(value);
};
